import React from 'react'
import { connect } from 'react-redux'
import { getFormValues, Field } from 'redux-form'
import ReactTable from 'react-table'
import { lower } from 'change-case'
import { numberFormat } from 'core/utilities'
import { StdCard, FileUploadCell } from 'components'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { goodsServiceReceiptDetailPath, purchaseOrderDetailPath } from 'routes'
import { BLContainer, RowFields, Cont, FooterCont, LinkInfo, FileRRR } from './styled'
import { filterInvoiceList, removeInvoiceItemList, addInvoiceItemList,
  resetInvoiceList, getBLGOAWorkFlowEditMode, getGRReleaseDetail
} from 'ducks/billform'

// import r from 'reactotron-react-js'

const Information = props => {
  const { valueForm, GRReleaseBuffer, grReleaseDetail, isCreate = false, isEdit = false } = props

  const [totalInvoiceAmount, setTotalInvoiceAmount] = React.useState(0)
  const [currency, setCurrency] = React.useState('')
  const [firstSelect, setFirstSelect] = React.useState(true)
  const [ivSelected, setIVSelected] = React.useState([])
  const [tempSelect, setTempSelect] = React.useState([])

  React.useEffect(() => {
    props.getBLGOAWorkFlowEditMode({
      creater: valueForm.createdByUser ? lower(valueForm.createdByUser) : '',
      requester: valueForm.requesterUser || '',
      companyCode: ivSelected.length > 0 ? (ivSelected[0] || {}).companyCode : ''
    })
  }, [valueForm.requesterUser, ivSelected])

  React.useEffect(() => {
    if (ivSelected.length > 0 && GRReleaseBuffer.length > 0) {
      let data = ivSelected[0] || {}
      setCurrency(data.currencyCode)
      let total = ivSelected.reduce((sum, i) => sum + (i.totalInvoiceAmount || 0), 0)
      props.change('totalAmount', total)
      setTotalInvoiceAmount(total)
      props.change('ivSelected', ivSelected)
    }
  }, [ivSelected])

  React.useEffect(() => {
    const { searchGoodsServiceReceipt } = valueForm

    if (searchGoodsServiceReceipt && GRReleaseBuffer.length > 0) {
      if (searchGoodsServiceReceipt.length > 0) {
        if (firstSelect === 0) {
          setFirstSelect(false)
          props.filterInvoiceList(searchGoodsServiceReceipt[0])
          setUpIVSelected()
        } else {
          setUpIVSelected()
        }
      } else {
        if (firstSelect > 0) {
          setFirstSelect(true)
          props.resetInvoiceList()
          setUpIVSelected()
        }
      }
    }

    if (searchGoodsServiceReceipt && GRReleaseBuffer.length > 0) {
      let sIVL = searchGoodsServiceReceipt.length
      let tIVL = tempSelect.length
      if (valueForm.start) {
        searchGoodsServiceReceipt.forEach(x => {
          props.getGRReleaseDetail(x)
        })
        setTempSelect(JSON.parse(JSON.stringify(searchGoodsServiceReceipt)))
      } else {
        if (sIVL !== tIVL) {
          if (sIVL > tIVL) {
            props.getGRReleaseDetail(searchGoodsServiceReceipt[sIVL - 1])
            setTempSelect(JSON.parse(JSON.stringify(searchGoodsServiceReceipt)))
          } else if (sIVL < tIVL) {
            if (sIVL === 0) {
              setUpIVSelected(null)
              setTempSelect([])
              setFirstSelect(true)
              // clear option to default
              props.resetInvoiceList()
            } else {
              let grIdDeleted = -1
              // find grId is deleted
              tempSelect.forEach((x, i) => {
                let index = searchGoodsServiceReceipt.findIndex(y => y === x)
                if (index < 0) {
                  grIdDeleted = x
                }
              })
              // delete from IVSelected
              setUpIVSelected(grIdDeleted, true)
              // delete from tempSelect
              let cloneTempSelect = JSON.parse(JSON.stringify(tempSelect))
              let indexTSDeleted = cloneTempSelect.findIndex(x => x === grIdDeleted)
              cloneTempSelect.splice(indexTSDeleted, 1)
              setTempSelect(cloneTempSelect)
            }
          }
        }
      }
    }
  }, [valueForm.searchGoodsServiceReceipt, GRReleaseBuffer])

  React.useEffect(() => {
    if (grReleaseDetail) {
      if ((valueForm.searchGoodsServiceReceipt || []).length > 0) {
        if (firstSelect) {
          setFirstSelect(false)
          props.filterInvoiceList(valueForm.searchGoodsServiceReceipt[0])
          setUpIVSelected(grReleaseDetail)
        } else {
          setUpIVSelected(grReleaseDetail)
        }
      }
    }
  }, [grReleaseDetail])

  const renderCompanyInfo = () => {
    let data = ivSelected[0]
    if (data) {
      return (
        <Cont>
          <div className='title'>Company Information</div>
          {/* Company Address */}
          <div className='rowI' >
            <div className='stBold'>{data.companyName}</div>
            <div className='stBold'>{`Tax Id : ${data.companyTaxId}`}</div>
          </div>
          {/* Address */}
          <div>
            {`Address : ${data.companyAddress}`}
          </div>
          {/* Delivery Address */}
          <div className='stBold'>Delivery Address</div>
          <div>{data.companyName}</div>
          <div>{data.companyAddress}</div>
        </Cont>
      )
    } else {
      return null
    }
  }

  const setUpIVSelected = (data, remove = false) => {
    if (remove) {
      let cloneIVSelected = JSON.parse(JSON.stringify(ivSelected))
      let indexIVDeleted = cloneIVSelected.findIndex(x => x.id === data)
      cloneIVSelected.splice(indexIVDeleted, 1)
      setIVSelected(cloneIVSelected)
    } else {
      if (data === null || data === undefined) {
        // clear select
        setIVSelected([])
      } else {
        let clone = JSON.parse(JSON.stringify(ivSelected))
        clone.push(data)
        setIVSelected(clone)
      }
    }
  }

  const setMember = () => {
    if (valueForm && valueForm.requesterUser) {
      let user = props.members.find(x => x.username.toLowerCase() === valueForm.requesterUser.toLowerCase())
      if (!user) {
        let result = props.members.map((m, i) => ({
          key: `${lower(m.username)}_${i}`,
          value: lower(m.username),
          text: `${m.firstnameEn} ${m.lastnameEn}`,
        }))
        result.push({
          key: `${lower(valueForm.requesterUser)}`,
          value: lower(valueForm.requesterUser),
          text: valueForm.requesterName
        })
        return result
      } else {
        return props.members.map((m, i) => ({
          key: `${lower(m.username)}_${i}`,
          value: lower(m.username),
          text: `${m.firstnameEn} ${m.lastnameEn}`,
        }))
      }
    } else {
      return []
    }
  }

  const column = [
    {
      Header: <div style={{ textAlign: 'start' }}>Invoice No.</div>,
      id: 'ivNumber',
      accessor: row => (row),
      Cell: row => (
        <LinkInfo onClick={() => window.open(goodsServiceReceiptDetailPath(row.value.id))}>{row.value.invoiceNumber}</LinkInfo>
      )
    }, {
      Header: 'Delivery Type',
      accessor: 'mainDeliveryType',
      className: 'center',
      width: 100,
    }, {
      Header: 'InvoiceAmount',
      accessor: 'totalInvoiceAmount',
      className: 'right',
      width: 100,
      Cell: row => numberFormat(row.value, true),
    }, {
      Header: 'Currency',
      accessor: 'currencyCode',
      className: 'center',
      width: 80,
    }, {
      Header: 'PO No.',
      id: 'pos',
      accessor: row => (row),
      className: 'center',
      Cell: row => {
        return (
          <div>
            {row.value.pos.map((x, i) => (
              <LinkInfo onClick={() => window.open(purchaseOrderDetailPath(x.id))}>{x.poSapNumber}</LinkInfo>
            ))}
          </div>)
      },
      width: 100,
    }
  ]

  return (
    <BLContainer>
      <StdCard title={<span className='stepTitle'>Step 1 : Title</span>}>
        <RowFields>
          <Field
            name='title'
            label='Title'
            require
            type={type.text}
            component={FieldInput}
            maxLength={200}
            maxLengthMessage='Title must be less than or equal to 200 characters'
          />
          <Field
            name='requesterUser'
            label='Requester'
            require
            editable={isCreate || isEdit}
            type={type.select}
            component={FieldInput}
            loading={props.members.loading}
            options={setMember()}
          />
        </RowFields>
      </StdCard>
      <div style={{ marginTop: '1rem' }} />
      <StdCard title={<span className='stepTitle'>Step 2 : Choose Invoices</span>}>
        {valueForm && valueForm.id && <RowFields>
          <Field
            name='searchGoodsServiceReceipt'
            label='Choose Purchase Order and Fill out the form'
            placeHolder=' Search GR Number, GR Title , PO Number, PO Title '
            require
            component={FieldInput}
            editable={true}
            loading={props.GRSearchLoading}
            options={props.GRRelease.map(x => ({
              value: x.id, text: `Invoice No. ${x.invoiceNumber}  | ${x.documentNumber}`
            }))}
            type={type.multiSelect}
          />
        </RowFields>}
        {ivSelected.length > 0 ? <div style={{ maxWidth: '100%' }}>{renderCompanyInfo()}</div> : null}
        <br />
        {ivSelected.length > 0 ?
          <RowFields>
            <div style={{ width: '100%', paddingRight: '0.9357rem', }}>
              <ReactTable
                data={ivSelected}
                columns={column}
                resizable={false}
                NoDataComponent={() => null}
                minRows={(valueForm.searchGoodsServiceReceipt || []).length > 10 ? 10 : (valueForm.searchGoodsServiceReceipt || []).length || 5}
                defaultPageSize={10}
                showPagination={false}
                className='-striped -highlight'
              />
              <FooterCont>
                {(valueForm.searchGoodsServiceReceipt || []).length > 0 &&
                  <div>
                    <div className='title'> {`Total (Inc.VAT)`} :</div>
                    <div className='value'>
                      <div className='amount'>{numberFormat((totalInvoiceAmount || 0), true)}</div>
                      <div className='right'>{currency} </div>
                    </div>
                  </div>
                }
              </FooterCont>
            </div>
          </RowFields>
          : null
        }
        <br />
        <Field
          name='remark'
          label='Remark :'
          type={type.textArea}
          component={FieldInput}
        />
      </StdCard>

      <div style={{ height: '1rem' }} />
      <StdCard title={<span className='stepTitle'>Step 3 : Upload Files</span>} >
        <RowFields>
          <FileRRR>
            <Field name='BL01' label='Receipt :' type={type.file} component={FieldInput} />
            {valueForm.billingAttachment && valueForm.billingAttachment.map((item) => (
              <FileUploadCell
                key='rattachment'
                fileName={item.filename}
                fileSize={item.size}
                deleted={item.deleted}
                urlPath={item.urlPath}
                onClickDelete={() => {
                  let index = valueForm.billingAttachment.findIndex(x => x.id === item.id)
                  props.change('formBL', `billingAttachment[${index}].deleted`, true)
                }}
              />
            ))}
          </FileRRR>
          <FileRRR>
            <Field name='BL02' label='Other documents :' type={type.file} component={FieldInput} />
            {valueForm.otherAttachment && valueForm.otherAttachment.map((item) => (
              <FileUploadCell
                key='oattachment'
                fileName={item.filename}
                fileSize={item.size}
                deleted={item.deleted}
                urlPath={item.urlPath}
                onClickDelete={() => {
                  let index = valueForm.otherAttachment.findIndex(x => x.id === item.id)
                  props.change('formBL', `otherAttachment[${index}].deleted`, true)
                }}
              />
            ))}
          </FileRRR>
        </RowFields>
      </StdCard>
    </BLContainer>
  )

}

const mapStateToProps = (state) => {
  return {
    valueForm: getFormValues('formBL')(state) || {},
    GRRelease: state.billform.GRSearch.data,
    GRReleaseBuffer: state.billform.GRSearch.buffer,
    GRSearchLoading: state.billform.GRSearch.loading,
    members: state.member.members,
    grReleaseDetail: state.billform.grReleaseDetail,
  }
}
const mapDispatchToProps = {
  filterInvoiceList,
  removeInvoiceItemList,
  addInvoiceItemList,
  resetInvoiceList,
  getBLGOAWorkFlowEditMode,
  getGRReleaseDetail
}

export default connect(mapStateToProps, mapDispatchToProps)(Information)
